module.exports = __webpack_public_path__ + "media/crypto/usdt-17c236ea.png";